import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { Box, Button, Paper, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import { envEndPoints } from "../../config";

function ChangeDateButton({ article, publishedDate, onDateChange }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");

  const toInputDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    return d.toISOString().split("T")[0];
  };

  const handleClick = (event) => {
    setSelectedDate(toInputDate(publishedDate));
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleConfirm = () => {
    if (!selectedDate) return;

    fetch(`${envEndPoints().baseUrl}/patcharticles/date/${article.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ newDate: selectedDate }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Date updated:", data);
        handleClose();
        if (onDateChange) onDateChange();
      })
      .catch((error) => {
        console.error("Error updating date:", error);
      });
  };

  return (
    <div>
      <Button color="primary" variant="outlined" onClick={handleClick} size="small" sx={{ gap: 0.5 }}>
        <CalendarTodayOutlinedIcon fontSize="small" />
        Change Date
      </Button>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Paper sx={{ p: 2 }}>
          <Typography variant="button" display="block" sx={{ mb: 1 }}>
            Select new date
          </Typography>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            style={{ fontSize: "14px", padding: "6px", display: "block", marginBottom: "12px" }}
          />
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button size="small" onClick={handleClose} color="inherit">
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleConfirm}
              disabled={!selectedDate}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Popover>
    </div>
  );
}

export default ChangeDateButton;
